import { Button, Grid } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ls } from 'shared/utils/ls';
import { useStyles } from './Success.styles';

const Success: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const { getLS, removeLS, setLS } = ls();
  const queryClient = useQueryClient();

  const option = getLS('option');
  const agency = JSON.parse(getLS('agency') || '{}');
  const projectId = getLS('projectId');

  const handleClick = () => {
    if (option) {
      if (option === 'check-in') {
        // captureMessage('user clicked on check-in now');
        history.push(`/talent/check-in/${projectId}`);
      } else {
        // captureMessage('user clicked on submit self-tape');
        history.push(`/talent/self-tapes/${projectId}`);
      }
    } else {
      // captureMessage('user clicked on go to dashboard');
      history.push('/talent/dashboard');
    }
    if (agency.resetToken) history.push(`/talent/auditions/audition_request`);
    removeLS('option');
    removeLS('projectId');
    removeLS('agency');
  };

  useEffect(() => {
    // captureMessage('user completed registration');
    queryClient.invalidateQueries(['me'], {
      refetchInactive: true,
    });

    setLS('is_completed_primary_details', true);
  }, []);

  return (
    <>
      <Grid item className={classes.root}>
        <img className={classes.logoCls} src="/casting-logo.png" alt="File Logo" />
        <Typography fontSize={30}>Congratulations!</Typography>
        <Typography fontSize={16} style={{ textAlign: 'center', marginTop: 20 }}>
          You have succesfully completed the registration process.
        </Typography>
        <Button
          data-cy="go-to-dashboard"
          color="primary"
          variant="contained"
          disableElevation
          fullWidth
          className={classes.buttonCls}
          onClick={handleClick}
        >
          {option
            ? option === 'check-in'
              ? 'Check-In Now'
              : 'Submit Self-tape'
            : agency.resetToken
              ? 'View Audition Request'
              : 'Go to Dashboard'}
        </Button>
      </Grid>
    </>
  );
};

export default Success;
